import { TbKey } from "react-icons/tb";

import { PERMISSIONS } from "@/constants/permissions";
import type { NavigationRoute } from "@/types/navigation-route";
import { APP_ROUTES_TO } from "@/utils/routes";

export const apiKeysRoutes: NavigationRoute[] = [
  {
    to: APP_ROUTES_TO.API_KEYS,
    meta: {
      label: "api_keys",
      order: 8,
      icon: TbKey,
      visibleInSidebar: true,
      permissions: [PERMISSIONS.AUTH_SVC_API_KEYS_VIEW],
    },
  },
];
